import {TableCell, TableRow} from "../../../components/table/CustomTable";
import CustomCheckBox from "../../../components/form/CustomCheckBox";
import CustomIcon from "../../../components/CustomIcon";
import CustomButton, {DangerButton, OutlinedButton} from "../../../components/CustomButton";
import {setManageUserModals} from "../../../redux/slices/manageUserSlice";
import {useDispatch} from "react-redux";
import {USER_STATE_INACTIVE} from "../constants";

export default function ManageUserTableFeatureItem({users, feature}) {


  const dispatch = useDispatch();
  const cols = Array.from(
    {length: 5},
    (_, i) => users.length > i ? users[i] : {}
  );

  return (
    <TableRow>

      <TableCell className="font-semibold">
        <div className="w-52">{feature.frontend_key}</div>
        
      </TableCell>

      {
        cols.map((user, index) => <TableCell className="text-center" key={index}>
          {user.id ? <CustomCheckBox disabled={user.state === USER_STATE_INACTIVE} checked={user.features.some((f)=>f.id === feature.id)}
                                     onChange={() => dispatch(setManageUserModals({modal: true, data: {user, feature}, isConfirm:true}))} className="justify-center"/> : ""}
        </TableCell>)
      }


    </TableRow>
  );
}
